export const LONG_STALE_TIME = 15 * 60 * 1000; // 15 minutes
